import '@babel/polyfill'; // Application

import 'jquery.cookie';
import 'bootstrap';
import 'bootstrap-toggle';
import 'bootstrap-validator';
window.waitingDialog = require('bootstrap-waitingfor');
import 'angular';
import 'angular-animate';
import 'angular-sanitize';
import 'ng-file-upload';
import 'angular-file-upload-shim';
import 'jquery-ui/ui/core';
import 'jquery-ui/ui/widget';
import 'jquery-ui/ui/widgets/mouse';
import 'jquery-ui/ui/widgets/sortable';
import 'angular-ui-sortable';
import 'angular-datetime-input';
import 'handlebars'; //1 critical vurnerabilities

import 'fastclick';
import moment from 'moment';
window.moment = moment;
import 'eonasdan-bootstrap-datetimepicker';
import 'easy-autocomplete';
import 'ckeditor4/ckeditor';
import 'ckeditor4/plugins/link/dialogs/link';
import 'ckeditor4/adapters/jquery';
import 'checklist-model'; //version 0.8.0

import 'file-saver';
import 'devbridge-autocomplete';
import '../../Models/Blocks/RssBlock/rssblock.js';
import 'jquery.dirtyforms';
import './components/leftNav.js';
import './components/util.js';
import './components/jquery.tablesorter.js'; //Fork availible https://github.com/Mottie/tablesorter

import './components/cookiebar.js';
import './alpacaforms/typeahead-0.10.5.js';
import 'alpaca';
import uuidv4 from './components/util.js';
window.uuidv4 = uuidv4;
import './components/ethic-forms.js';
import './components/vimeoSettings.js';
import './App/lifClientApp.js';
import './App/controllers/searchController.js';
import './App/controllers/aboutController.js';
import './App/controllers/calendarEventsListingBlockController.js';
import './App/controllers/fileBlockController.js';
import './App/controllers/leftNavigationController.js';
import './App/controllers/linkListBlockController.js';
import './App/controllers/loginController.js';
import './App/controllers/meetingsBlockController.js';
import './App/controllers/meetingsFileBlockController.js';
import './App/controllers/memberListBlockController.js';
import './App/controllers/referralController.js';
import './App/controllers/registerController.js';
import './App/controllers/shoutoutBlockController.js';
import './App/controllers/catalogStructureWithFileBlockController.js';
import './App/Services/formService.js';
import './App/Services/userService.js';
import './App/Filters/linkFilter.js';
import './App/Filters/mainLinkFilter.js';
import './App/Filters/unsafeHtmlFilter.js';
import './App/Directives/ngEnterDirective.js';
import './App/Directives/ngOnErrorSrcDirective.js';
import './App/checkOldBrowser.js'; // Styling

import '../less/app.less';